import React from 'react';

import styles from './PermissionItem.less';

interface PermissionItemProps {
  label: string;
  scope: 'unit' | 'subUnit';
}

const isUnit = (scope: 'unit' | 'subUnit') => scope === 'unit';

export const PermissionItem: React.FC<PermissionItemProps> = ({
  label,
  scope,
}) => (
  <div className={styles.container}>
    <span className={isUnit(scope) ? styles.unitDot : styles.subUnitDot} />
    <span className={styles.label}>{label}</span>
  </div>
);
